import type {
  IPagedFilterTownshipAreaDto,
  ITownshipAreaCreateOrUpdateDto,
  ITownshipAreaOutputDto,
} from "@models/master-data/townshipAreaModel"
import townshipAreaService from "@services/master-data/townshipAreaService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import { action, makeAutoObservable, observable } from "mobx"

class TownshipAreaStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<ITownshipAreaOutputDto>
  @observable detailData!: ITownshipAreaOutputDto | null

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
  }

  @action
  async createOrUpdate(body: ITownshipAreaCreateOrUpdateDto) {
    this.isLoading = true
    const result = await townshipAreaService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    this.detailData = result
    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) return result
        return x
      })
    }
  }

  @action
  async newTownshipArea() {
    this.detailData = {
      id: 0,
      code: "",
      name: "",
      isActive: true,
    }
  }

  @action
  async active(id: number, isActive: boolean) {
    this.isLoading = true
    await townshipAreaService
      .activate(id, isActive)
      .finally(() => (this.isLoading = false))
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await townshipAreaService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
    return result
  }

  @action
  async getAll(params: IPagedFilterTownshipAreaDto) {
    this.isLoading = true
    const result = await townshipAreaService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
}

export default TownshipAreaStore
